import React from 'react';
import Main from '../../organisms/Main/Main';
import Header from '../../organisms/Header/Header';

function Bestseller() {
	return (
		<>
			<Header />
			<Main title='Bestsellery' status='hit' />
		</>
	);
}

export default Bestseller;
